<template>

<div>
  <div class="footer">
    <div class="contact">
      <h3>Visit our commerce store at:</h3>
      <p>
        56 Old Town Road <br />
        Middle Earth <br />
        00001
      </p>
    </div>
    <div class="CC">
      <h3>Be a part of a community</h3>
      <a class ='cclink' href='https://the-creature-collab.herokuapp.com/' target="_blank" rel="noopener noreferrer"> CC </a>
    </div>
    <div class="sign">
      <h3>Sign up for our mailing list for 30% off your first purchase!</h3>
      <div class="input-and-butt">
        <input placeholder="Email">
        <button>Sign Up!</button>
      </div>
    </div>
  </div>
    <div class="below-footer">
        <div class="below-footer-1">
          <h6>@ 2022 CreatureComm, Inc.</h6>
        </div>
        <div class="below-footer-2">
          <h6>Terms</h6>
        </div>
        <div class="below-footer-3">
          <h6>Privacy Policy</h6>
        </div>
        <div class="below-footer-4">
          <h6>Copyright Policy</h6>
        </div>
        <div class="below-footer-5">
          <h6>Contact</h6>
        </div>
    </div>
</div>
  
</template>

<script>
export default {
  name: "Foot",
};
</script>

<style scoped></style>